import type { OcppSettingsUpdate, ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const updateOcppSettings: UseCase<ChargerRepository, 'updateOcppSettings'> = repository => {
  return async (ocppSettingsUpdate: OcppSettingsUpdate) => {
    await repository.updateOcppSettings(ocppSettingsUpdate)
  }
}
